import { render, staticRenderFns } from "./EditPressNewDetail.vue?vue&type=template&id=b7c6449c"
import script from "./EditPressNewDetail.vue?vue&type=script&lang=js"
export * from "./EditPressNewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports